import { render, staticRenderFns } from "./CustomerInactivityModal.vue?vue&type=template&id=50299d7e&scoped=true&"
import script from "./CustomerInactivityModal.vue?vue&type=script&lang=ts&"
export * from "./CustomerInactivityModal.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerInactivityModal.vue?vue&type=style&index=0&id=50299d7e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50299d7e",
  null
  
)

export default component.exports